







































































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import LoadingIndicator from '@components/LoadingIndicator'

settings =
  name: 'PersonaTimeWindowsTriggerModal'

  resources:
    personas:
      resourceName: 'persona'
      slug: 'suppliers/:supplierId/venues/:venueId/personas'
      fetch: false
    persona:
      resourceName: 'persona'
      slug: 'suppliers/:supplierId/venues/:venueId/personas/:selectedPersonaId/edit'
      fetch: false

  vue:
    props: ['options']

    components: {
      Modal,
      RequestButton,
      LoadingIndicator,
    }

    data: ->
      modal:
        show: false

      selectedPersonaId: null
      pastRelevantEvents: null
      preselectedDate: null

    computed:
      supplierId: ->
        @options?.supplierId

      venueId: ->
        @options?.venueId

      audienceCreativeId: ->
        @options?.audienceCreativeId

      selectedPersona: ->
        @personas.find((persona) => persona.id is @selectedPersonaId)

      personasSorted: ->
        personas = [...(@personas || [])]
        personas.sort((a, b) =>
          aHasDates = a.past_relevant_dates.length > 0
          bHasDates = b.past_relevant_dates.length > 0
          if aHasDates isnt bHasDates
            return if aHasDates then 1 else -1
          a.creative_title.localeCompare b.creative_title
        )
        personas

      hasPastRelevantEventsEmpty: ->
        return true if !@pastRelevantEvents?.length
        return true if @flatten(@pluck(@pastRelevantEvents, 'period')).length isnt @pastRelevantEvents.length * 2
        false

      canAddTimeWindow: ->
        @selectedPersona and @pastRelevantEvents.length < 10

      dateTimePickerOptions: ->
        onPick: @onPickDateTimeRange
        disabledDate: @shouldDisableDate

    methods:
      onLoadCollectionCompleted: (resourceKey) ->
        switch resourceKey
          when 'personas'
            if @audienceCreativeId
              persona = @personas.find((persona) => persona.creative_id is @audienceCreativeId)
              @setSelectedPersonaId persona?.id
            else if @personas.length is 1
              persona = @personas[0]
              @setSelectedPersonaId persona.id

      hiChangeSelectedPersona: ->
        @setSelectedPersonaId @selectedPersonaId

      hiDateTimeChanged: (dateRange, index) ->
        @pastRelevantEvents[index].ugc = true
        return unless dateRange
        [start, end] = dateRange
        @pastRelevantEvents[index].period[1] = end.replace(' 00:00', ' 23:59') if end.endsWith(' 00:00')

      hiBlurDateTimePicker: ->
        @resetPreselectedDate()

      hiAddTimeWindowRow: ->
        @addTimeWindowRow()

      hiRemoveTimeWindowRow: (index) ->
        @removeTimeWindowRow index

      hiSave: ->
        @selectedPersona.past_relevant_dates = @pastRelevantEvents.map(({ period: [starts_on, ends_on], ugc }) => ({ starts_on, ends_on, ugc }))
        @saveItem 'prime.persona', @selectedPersona
        @close() if @audienceCreativeId

      setSelectedPersonaId: (personaId) ->
        @selectedPersonaId = personaId
        @resetPastRelevantEvents()

      addTimeWindowRow: ->
        @pastRelevantEvents = [...@pastRelevantEvents, { period: [], ugc: true }]

      removeTimeWindowRow: (index) ->
        @pastRelevantEvents.splice index, 1

      resetPastRelevantEvents: ->
        return unless @selectedPersona
        @pastRelevantEvents = @selectedPersona.past_relevant_dates.map(({ starts_on, ends_on, ugc }) => ({ period: [starts_on, ends_on], ugc }))
        @addTimeWindowRow() if @pastRelevantEvents.length is 0

      shouldDisableDate: (date) ->
        start = dayjs().subtract(30, 'months')
        end = dayjs()

        if @preselectedDate
          limitRangeInDays = 7
          baseDate = dayjs @preselectedDate
          newStart = baseDate.add -limitRangeInDays, 'day'
          newEnd = baseDate.add limitRangeInDays, 'day'
          start = dayjs.max start, newStart
          end = dayjs.min end, newEnd

        !dayjs(date).isBetween(start, end, 'day')

      onPickDateTimeRange: (dateRange) ->
        if dateRange.maxDate
          @resetPreselectedDate()
        else
          @preselectedDate = dateRange.minDate

      resetPreselectedDate: ->
        @preselectedDate = null

      reset: ->
        @modal.show = false
        @selectedPersonaId = null
        @pastRelevantEvents = null

      # public

      open: ->
        @modal.show = true
        @fetch 'personas'

      close: ->
        @modal.show = false

    watch:
      'modal.show': (show) ->
        @reset() unless show

export default VueOptions.vue settings
